import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {toast} from 'react-toastify';

import Button from 'components/Button';
import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import useModalService from 'components/shared/ModalService';
import useAppContext from 'conf/AppContext';
import ProfileForm from 'pages/protected/dashboard/profile/Form';


export default function ProfilePage() {
  const appContext = useAppContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const modalService = useModalService();
  const navigate = useNavigate();


  useEffect(() => {
    const abortController = new AbortController();
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/profile', {
          parseJson: true,
        }, abortController);
        setData(rez?.data?.user);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
          navigate('/');
        }
        setError(err);
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();

    return () => {
      abortController.abort();
    };

  }, []);


  const closeHandler = () => {
    modalService.close();
  };

  const saveHandler = (val) => {
    setData(val.data.user);
    toast.success('Your profile successfully updated!');
    modalService.close();
  };

  const openEditEditor = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    let user;
    const closestAncestor = evt.target.closest('button[data-id]');
    if (closestAncestor && closestAncestor.getAttribute('data-id')) {
      user = closestAncestor.getAttribute('data-id');
      if (!user) {
        appContext.toastError(`Cannot find company ${user}! Try reloading the page.`);
        return;
      }
    } else {
      appContext.toastError('Cannot find data-id! Try reloading the page.');
      return;
    }

    if (error) {
      setError(false);
    }

    modalService.open({
      closeHandler,
      style: {
        width: '40em',
        overflow: 'unset',
      },
      content: (
        <ProfileForm
          data={data}
          readOnly={false}
          onSave={saveHandler}
          onClose={closeHandler}
        />
      ),
    },
    );
  };
  
  const renderUserBtn = () => (
    <div className="mt-3 text-end">
      <Button
        actionHandler={openEditEditor}
        data-id="user"
        className="btn btn-lg btn-primary"
      >
        Edit
      </Button>
    </div>
  );

  let body = <Loading />;
  if (data) {
    body = (
      <ProfileForm
        data={data}
        readOnly={true}
        onSave={saveHandler}
        onClose={closeHandler}
      />
    );
  } else if (error) {
    body = <KyError kyError={error} />;
  }
  
  return (
    <>
      {body}
      {renderUserBtn()}
    </>
  );
  
}
